function isFunction(fun) {
    return typeof(fun) === 'function';
}

export default function isDate(value) {
    return Boolean(value) && isFunction(value.getTime) && isFunction(value.getMonth);
}



//////////////////
// WEBPACK FOOTER
// ./~/@telerik/kendo-intl/dist/es/common/is-date.js
// module id = 233
// module chunks = 93